<template>
  <div :style="adaptContainStyl" ref="articleAdaptiveRefs">
      <div class="adaptive-one" v-for="(item, index) in articleDataList" :key="index" @click="skipLinks(item)" :style="articleContainStyl" @mouseover="overArticleItem(item)">
          <div class="title-box" :style="mainTitle">{{showContentType == '2'? item.articleTitle: item.titleName}}</div>
          <div class="publish">
              <!-- <div class="read-num">{{'我是大眼睛'}}</div> -->
              <div class="read-num" v-if="publishContent.showReadFlag&&item.readNum">
                  <img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px">
                  {{ item.readNum}}
                  </div>
              <div class="time-box" v-if="publishContent.showPublishFlag&&item.publishTime">{{ item.publishTime | formatTime}}</div>
          </div>
      </div>
  </div>
</template>

<script>
import { getDataLrFn, commonClickFn } from './commonModuleFn'
export default {
    name: 'adaptive-one',
    props:{
        receiveProps:{
            type: [Object, Array],
            default: ()=>{}
        }
    },
    computed:{
        adaptContainStyl(){
            let { topBottomInterval } = this.publishStyl;
            return {
                margin: `-${topBottomInterval}px auto`,
                marginLeft: this.isBanner? '': '24px'
            }
        },
        articleContainStyl(){
            let { oneGroupBorder, oneGroupBGColor, oneGroupBorderShadow, oneGroupBorderRadius, topBottomInterval } = this.publishStyl;
            return {
                border: oneGroupBorder? "1px solid #d6deea" : '',
                backgroundColor: oneGroupBGColor,
                boxShadow: oneGroupBorderShadow?"0px 0px 16px 0px rgba(0, 0, 0, 0.1)": '', 
                borderRadius: oneGroupBorderRadius? "4px": '', // 判断是否是圆角
                margin: `${topBottomInterval}px auto`, // item上下间距
                '--article-contain-hover': this.showPointer ? "pointer" : "",
            }
        },
        mainTitle() {
            let { titleAlign, titleBold, titleColor, titleSize, titleLineHeight } = this.publishStyl;
            return {
              color: titleColor,
              fontSize: `${titleSize}px`,
              fontWeight: titleBold? '700': "",
              textAlign: titleAlign,
              lineHeight: titleLineHeight
            };
    },
    },
    data(){
        return {
            showPointer: false,
            showContentType: '1',
            publishContent: this.receiveProps.tempData.specialData,
            publishStyl: this.receiveProps.tempData.specialStyle,
            articleDataList: [],
            paging: {
                params: {
                  pageNum: 1,
                  pageSize: 10000,
                },
                total: 0,
                    },
            isBanner: true, // true为通栏   false为二分栏或1-2分栏
        }
    },
    filters: {
    formatTime(val) {
      return (
        val.split(" ")[0].split("-").join("/") 
      )
    }
  },
  mounted(){
        getDataLrFn(this)
        let classArr = this.$refs.articleAdaptiveRefs.parentNode.parentNode.classList
        for(var i=0;i<classArr.length;i++){ //获取父节点  el-col-24  el-col-12
        if(classArr[i]=='el-col-12' || classArr[i]=='el-col-16'){
          this.isBanner = false
        } 
      }
      console.log('=======>isBanner-----', this.isBanner)
      console.log('======>classArr', classArr)
    //   el-col-16
  },
  methods:{
      skipLinks(item){
          commonClickFn(item, this.publishContent, this)
      },
      overArticleItem(item){
      // 直接调取有手指  自由设置看是否有链接
      let {showContentType} = this.receiveProps.tempData.specialData
      let {selectUrlType, selectType} = item
      if(showContentType != 2){ 
      if(selectUrlType || selectType ==2){
        this.showPointer = true
        return 
      }
         this.showPointer = false
      } else {
        this.showPointer = true
      }
    },
  }
}
</script>

<style lang="less" scoped>
.adaptive-one{
    width: 100%;
    margin: 0 auto 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    line-height: 26px;
    &:last-child{
        margin-bottom: 0;
    }
    &:hover{
        cursor: var(--article-contain-hover);
    }
    .title-box{
        height: 26px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        word-break: break-all;
    }
    .publish{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 24px;
        .read-num{
            font: 400 14px PingFangSC-Regular, PingFang SC;
            color: #666666;
            display: flex;
            align-items: center;
            img{
                margin-right: 8px;
            }
        }
        .time-box{
            margin-left: 24px;
            font: 400 14px PingFangSC-Regular, PingFang SC;
            color: #999999;
        }
    }
    
}
</style>